module.exports = __webpack_public_path__ + "img/logo.bd1906d7.png";